// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"settingsSupplierForm_checkbox__3x2G5","checkbox-wrapper":"settingsSupplierForm_checkbox-wrapper__3b4_W","checked":"settingsSupplierForm_checked__DrWe7"};